import { render, staticRenderFns } from "./RegisterFacilityManager.vue?vue&type=template&id=6087f7d6"
import script from "./RegisterFacilityManager.vue?vue&type=script&lang=js"
export * from "./RegisterFacilityManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports